import { render, staticRenderFns } from "./FastSelect.vue?vue&type=template&id=2abba943&scoped=true"
import script from "./FastSelect.vue?vue&type=script&lang=ts"
export * from "./FastSelect.vue?vue&type=script&lang=ts"
import style0 from "./FastSelect.vue?vue&type=style&index=0&id=2abba943&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abba943",
  null
  
)

export default component.exports